import type { PropsWithChildren } from 'react'
import { Box, Text } from '@machobear/design-system'

import * as styles from './corner-ribbon.css'

const CornerRibbon: React.FC<PropsWithChildren> = ({ children }) => (
  <Box
    overflow="hidden"
    position="absolute"
    top={0}
    right={0}
    className={styles.wrapper}
  >
    <Box
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
      background="customDark"
      className={styles.ribbon}
    >
      <Text size="xsmall" weight="strong">
        {children}
      </Text>
    </Box>
  </Box>
)

export default CornerRibbon
